var _path, _mask, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8696 6.60869C14.8696 5.15577 14.2924 3.76235 13.265 2.73498C12.2376 1.7076 10.8442 1.13043 9.3913 1.13043C7.93838 1.13043 6.54496 1.7076 5.51759 2.73498C4.49022 3.76235 3.91304 5.15577 3.91304 6.60869C3.91304 13 1.17391 14.8261 1.17391 14.8261H17.6087C17.6087 14.8261 14.8696 13 14.8696 6.60869Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 14.4348C13.0435 15.4034 12.6587 16.3323 11.9738 17.0173C11.2889 17.7022 10.3599 18.087 9.3913 18.087C8.42269 18.087 7.49374 17.7022 6.80883 17.0173C6.12391 16.3323 5.73913 15.4034 5.73913 14.4348L9.3913 14.4348H13.0435Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 14.4348C13.0435 15.4034 12.6587 16.3323 11.9738 17.0173C11.2889 17.7022 10.3599 18.087 9.3913 18.087C8.42269 18.087 7.49374 17.7022 6.80883 17.0173C6.12391 16.3323 5.73913 15.4034 5.73913 14.4348L9.3913 14.4348H13.0435Z",
    stroke: "#13100D",
    strokeWidth: 2,
    mask: "url(#path-3-inside-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f442b31bd5130dbcc9e8462afa805a6b.svg";
export { ForwardRef as ReactComponent };